import {
  Box,
  createStyles,
  LinearProgress,
  Typography,
  useTheme,
} from "@material-ui/core";
import React from "react";
import { formatMoney } from "nemuru-components";
import { usePaymentPlanProgress } from "../hooks/usePaymentPlanProgress";
import Text from "../../../../../../shared/components/Text";
import { withStyles } from "@material-ui/core/styles";

export const PaymentPlanProgress = ({
  paymentPlan,
  currentPaymentPlanLine,
}) => {
  const { customBorderRadius } = useTheme();

  const { totalPaidNumber, totalPaidAmount, remainingAmount, totalAmount } =
    usePaymentPlanProgress(paymentPlan, currentPaymentPlanLine);

  const progress = Math.round((totalPaidAmount / totalAmount) * 100);

  return (
    <>
      <Box
        p={2}
        display={"flex"}
        flexDirection={"column"}
        alignItems={"flex-end"}
        // bgcolor={"grey.50"}
        borderRadius={customBorderRadius.paper}
      >
        <Box width={"100%"} display={"flex"} color={"text.title"}>
          <Box
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            flex={"1 0 0"}
          >
            <Typography variant={"h6"}>
              <strong>{formatMoney(totalPaidAmount, 2)}</strong>
            </Typography>
            <Typography variant={"caption"} color={"textSecondary"}>
              <Text tId={"TOTAL_PAID_AMOUNT"} />
            </Typography>
          </Box>
          <Box
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            flex={"1 0 0"}
          >
            <Typography variant={"h6"}>
              <strong>{formatMoney(remainingAmount, 2)}</strong>
            </Typography>
            <Typography variant={"caption"} color={"textSecondary"}>
              <Text tId={"TOTAL_REMAINING_AMOUNT"} />
            </Typography>
          </Box>
        </Box>
        <Box
          mt={2}
          width={"100%"}
          display={"flex"}
          justifyContent={"space-between"}
          color={"text.secondary"}
        >
          <Typography variant={"caption"}>
            <Text tId={"INSTALMENTS_PAID"} />
          </Typography>
          <Typography variant={"caption"}>
            {`${totalPaidNumber} `}
            <Text tId={"OF"} />
            {` ${paymentPlan.lines.length}`}
          </Typography>
        </Box>
        <Box width={"100%"} mt={1}>
          <StyledLinearProgress value={progress} variant={"determinate"} />
        </Box>
      </Box>
    </>
  );
};

const StyledLinearProgress = withStyles((theme) =>
  createStyles({
    colorPrimary: {
      backgroundColor: theme.palette.grey[200],
    },
    bar: {
      backgroundColor: theme.palette.info.main,
    },
  })
)(LinearProgress);
